<button style="width: inherit;" class="tw-cursor-pointer tw-uppercase tw-py-2 tw-px-4 tw-rounded-sm tw-border-transparent tw-bg-yellow tw-text-black hover:tw-bg-yellow tw-text-base tw-font-bold hover:tw-border-1 hover:tw-border-yellow disabled:tw-bg-grayMid disabled:tw-text-grayDark disabled:tw-border-tertiary" type="button" (click)="onButtonClick()"
  gaEvent="gaEventTag" gaCategory="action_event">
  {{title}}
  <ng-content></ng-content>
</button>